export default "__VITE_ASSET__bga0JkEp__"